import { Permission } from '@aeCore/constants/permission.consts';
import { INavMenuSection } from '@aeCore/interfaces/nav-menu.interface';

/**
 * Sidebar navigation menu — aeda Admin MVP.
 * Sections & ordering match the Figma design (01 — Dashboard).
 */
export const ADMIN_NAV: INavMenuSection[] = [
  {
    label: 'OVERVIEW',
    items: [
      { label: 'Dashboard', icon: '⊞', route: '/dashboard' },
    ],
  },
  {
    label: 'USER OPS',
    items: [
      { label: 'Users', icon: '👥', route: '/users', permission: [Permission['User']['VIEW']] },
      { label: 'Partner KYC Monitor', icon: '◉', route: '/partner-kyc', permission: [Permission['PartnerKyc']['VIEW']] },
      {
        label: 'Transactions',
        icon: '⇄',
        route: '/transactions',
        permission: [Permission['Transaction']['VIEW']],
      },
    ],
  },
  {
    label: 'CONFIGURATION',
    items: [
      {
        label: 'Fee & Pricing',
        icon: '◎',
        route: '/fee-pricing',
        permission: [Permission['Fee']['VIEW']],
      },
      {
        label: 'Country Lane Management',
        icon: '⊕',
        route: '/country-lane-management',
        permission: [Permission['CountryLane']['VIEW']],
      },
      {
        label: 'FX Configuration',
        icon: '◈',
        route: '/fx-config',
        permission: [Permission['FxConfig']['VIEW'], Permission['FxConfig']['EDIT']],
      },
      {
        label: 'Partners',
        icon: '⬡',
        route: '/partners',
        permission: [Permission['Partner']['VIEW']],
      },
    ],
  },
  {
    label: 'SYSTEM',
    items: [
      {
        label: 'Admin Users',
        icon: '⚙',
        route: '/admin-users',
        permission: [
          Permission['Role']['VIEW'],
          Permission['Admin']['VIEW_ADMIN'],
        ],
      },
      { label: 'System Settings', icon: '≡', route: '/settings' },
    ],
  },
];

/** Deferred post-launch items shown dimmed at the bottom of the sidebar. */
export const DEFERRED_NAV_ITEMS: string[] = [
  '· Wallets',
  '· Currencies (multi)',
  '· Reports & Analytics',
  '· Notifications',
];
